import { useRef, useState } from "react";
import { Markdown, Textarea, Btn } from "./ui";

export const Editor = ({ value, onChange, placeholder = "Írd ide a hozzászólásod… (BBCode támogatott)", rows = 8, testId = "editor" }) => {
  const [preview, setPreview] = useState(false);
  const wrapRef = useRef(null);
  const wrap = (open, close, def = "") => {
    const ta = wrapRef.current?.querySelector("textarea");
    if (!ta) return;
    const s = ta.selectionStart;
    const e = ta.selectionEnd;
    const sel = value.slice(s, e) || def;
    onChange(value.slice(0, s) + open + sel + close + value.slice(e));
    setTimeout(() => { ta.focus(); ta.setSelectionRange(s + open.length, s + open.length + sel.length); }, 0);
  };
  const askUrl = (label) => window.prompt(label, "https://");
  const tools = [
    { l: "B", t: "Félkövér", f: () => wrap("[b]", "[/b]", "szöveg"), c: "font-bold" },
    { l: "I", t: "Dőlt", f: () => wrap("[i]", "[/i]", "szöveg"), c: "italic" },
    { l: "U", t: "Aláhúzott", f: () => wrap("[u]", "[/u]", "szöveg"), c: "underline" },
    { l: "S", t: "Áthúzott", f: () => wrap("[s]", "[/s]", "szöveg"), c: "line-through" },
    { l: "Méret", t: "Betűméret", f: () => { const n = window.prompt("Betűméret (10-32)", "20"); if (n) wrap(`[size=${parseInt(n, 10) || 20}]`, "[/size]", "szöveg"); } },
    { l: "Link", t: "Link", f: () => { const u = askUrl("Link címe"); if (u) wrap(`[url=${u}]`, "[/url]", "link szövege"); } },
    { l: "Kép", t: "Kép beszúrása", f: () => { const u = askUrl("Kép URL címe"); if (u) wrap("[img]" + u, "[/img]"); } },
    { l: "Idézet", t: "Idézet", f: () => wrap("[quote]", "[/quote]", "idézet") },
    { l: "Kód", t: "Kód", f: () => wrap("[code]", "[/code]", "kód") },
    { l: "Lista", t: "Lista", f: () => wrap("[list]\n[*]", "\n[/list]", "elem") },
    { l: "Közép", t: "Középre", f: () => wrap("[center]", "[/center]", "szöveg") },
    { l: "Jobb", t: "Jobbra", f: () => wrap("[right]", "[/right]", "szöveg") },
  ];
  const colors = ["#ef4444", "#f97316", "#eab308", "#22c55e", "#5eb1ff", "#a855f7", "#ec4899", "#ffffff"];
  return (
    <div ref={wrapRef} className="rounded-2xl border border-white/10 bg-white/[0.02]" data-testid={testId}>
      <div className="flex items-center justify-between border-b border-white/[0.06] px-3 py-2">
        <div className="flex gap-1 font-mono text-[11px]">
          <button type="button" onClick={() => setPreview(false)} data-testid={`${testId}-write`} className={`rounded-full px-3 py-1 ${!preview ? "bg-white/10 text-white" : "text-white/50 hover:text-white"}`}>Írás</button>
          <button type="button" onClick={() => setPreview(true)} data-testid={`${testId}-preview`} className={`rounded-full px-3 py-1 ${preview ? "bg-white/10 text-white" : "text-white/50 hover:text-white"}`}>Előnézet</button>
        </div>
      </div>
      {!preview && (
        <div className="flex flex-wrap items-center gap-1 border-b border-white/[0.06] px-3 py-2 text-xs">
          {tools.map((b) => (
            <button key={b.l} type="button" title={b.t} onClick={b.f} className={`rounded-md border border-white/10 px-2 py-1 text-white/70 hover:bg-white/10 hover:text-white ${b.c || ""}`}>{b.l}</button>
          ))}
          <span className="mx-1 h-4 w-px bg-white/10" />
          {colors.map((col) => (
            <button key={col} type="button" title={`Szín ${col}`} onClick={() => wrap(`[color=${col}]`, "[/color]", "szöveg")} className="h-5 w-5 rounded-full border border-white/20" style={{ background: col }} />
          ))}
        </div>
      )}
      {preview ? (
        <div className="min-h-[160px] px-4 py-3" data-testid={`${testId}-preview-pane`}>
          {value.trim() ? <Markdown>{value}</Markdown> : <p className="text-sm text-white/30">Nincs mit megjeleníteni.</p>}
        </div>
      ) : (
        <Textarea value={value} onChange={(e) => onChange(e.target.value)} rows={rows} placeholder={placeholder} className="rounded-none border-0 bg-transparent focus:border-0" data-testid={`${testId}-textarea`} />
      )}
    </div>
  );
};

export const ReplyBox = ({ onSubmit, busy, placeholder, initial = "" }) => {
  const [value, setValue] = useState(initial);
  const submit = async (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    await onSubmit(value);
    setValue("");
  };
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="reply-form">
      <Editor value={value} onChange={setValue} rows={6} placeholder={placeholder} testId="reply-editor" />
      <div className="flex justify-end">
        <Btn type="submit" disabled={busy || !value.trim()} data-testid="reply-submit">Válasz küldése</Btn>
      </div>
    </form>
  );
};

